// extracted by mini-css-extract-plugin
export default {"messageForm":"styles_messageForm__U9vUM","input":"styles_input__HNkS7","sendButton":"styles_sendButton__oQ2N+","logo":"styles_logo__iXjGD"};